import {
  Swiper, Keyboard, Navigation,
} from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const swiperContainerClass = '.accommodation__swiper';

function addFocusClass(slide) {
  if (slide.classList.contains('cs-card')) {
    slide.classList.add('cs-card--focus');
  }
}

function removeFocusClass(slide) {
  if (slide.classList.contains('cs-card--focus')) {
    slide.classList.remove('cs-card--focus');
  }
}

function getCsCards(slider) {
  return slider.el.querySelectorAll('.cs-card');
}

function initSlider(container) {
  const swiper = new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: 8,
    modules: [Keyboard, Navigation],
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.accommodation__button-next',
      prevEl: '.accommodation__button-prev',
      disabledClass: 'c-arrow--disabled',
    },
    on: {
      slideChange() {
        if (window.innerWidth < breakpoints.lg) {
          this.wrapperEl.style.transform = `translate3d(-${this.slides[this.activeIndex].offsetLeft - 16}px, 0, 0)`;
        }
      },
      afterInit() {
        const csCards = getCsCards(this);

        csCards.forEach((card) => {
          card.addEventListener('mouseenter', (e) => {
            e.target.style.transition = 'all 0.7s ease-out';
          });
        });
      },
    },
  });

  // Get all slides
  const slides = swiper.el.querySelectorAll('.accommodation__slide');
  const lastSlide = slides[slides.length - 1];
  const firstSlide = slides[0];

  if (window.innerWidth > breakpoints.lg) {
    // Add event listeners for focus and blur
    slides.forEach((slide, index) => {
      const link = slide.querySelector('.c-button');

      slide.addEventListener('focus', () => {
        addFocusClass(slide);
        swiper.slideTo(index, 700, false);
      });

      slide.addEventListener('blur', () => {
        removeFocusClass(slide);
      });

      if (link) {
        link.addEventListener('focus', () => {
          addFocusClass(slide);
          swiper.slideTo(index, 700, false);
        });

        link.addEventListener('blur', () => {
          removeFocusClass(slide);
        });
      }
    });

    lastSlide.addEventListener('mouseenter', () => {
      firstSlide.classList.add('accommodation__slide--margin');
    });

    lastSlide.addEventListener('mouseleave', () => {
      firstSlide.classList.remove('accommodation__slide--margin');
    });

    lastSlide.addEventListener('focus', () => {
      firstSlide.classList.add('accommodation__slide--margin');
    });

    lastSlide.addEventListener('blur', () => {
      firstSlide.classList.remove('accommodation__slide--margin');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const initAllSliders = () => {
    const sliderContainers = document.querySelectorAll(swiperContainerClass);
    sliderContainers.forEach((el) => {
      initSlider(el);
    });
  };

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/accommodation', () => {
      initAllSliders();
    });
  } else {
    setTimeout(() => {
      initAllSliders();
    }, 1000);
  }
});

window.addEventListener('load', () => {
  const sliderContainers = document.querySelectorAll(swiperContainerClass);
  sliderContainers.forEach((slider) => {
    const csCards = slider.querySelectorAll('.cs-card--no-events');
    csCards.forEach((el) => {
      el.classList.remove('cs-card--no-events');
    });
  });
});
